import type { FunctionComponent } from 'react';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@trello/nachos/button';

import * as styles from './CardBackLoadingError.module.less';

// eslint-disable-next-line @trello/assets-alongside-implementation
import tacoSleepSvg from 'resources/images/taco-sleep.svg';

interface CardBackLoadingErrorProps {
  onClose?: () => void;
}

const reloadPage = () => window.location.reload();

export const CardBackLoadingError: FunctionComponent<
  CardBackLoadingErrorProps
> = (props) => {
  useEffect(() => {
    // eslint-disable-next-line @trello/no-query-selector
    const windowHolder = document.querySelector<HTMLElement>('.window');
    if (windowHolder !== null) {
      windowHolder.style.display = 'block';
      document.body.classList.add('window-up');
    }

    return () => {
      if (windowHolder !== null) {
        windowHolder.style.display = 'none';
        document.body.classList.remove('window-up');
      }
    };
  });

  return (
    <div className={`${styles.errorMessage}`}>
      <button
        className={'icon-md icon-close dialog-close-button js-close-window'}
        onClick={props.onClose}
      />
      <div className={'u-clearfix'}>
        <img alt="Taco" src={tacoSleepSvg} />
        <h4 id="js-dialog-title">
          <FormattedMessage
            id="templates.error.card-detail-loading-error"
            defaultMessage="The card could not be loaded at this time."
            description="Error message when a card fails to load"
          />
        </h4>
        <p>
          <FormattedMessage
            id="templates.error.reload-call-to-action"
            defaultMessage="You may want to try reloading this page."
            description="Retry message when a card fails to load"
          />
        </p>
        <Button appearance={'primary'} onClick={reloadPage}>
          <FormattedMessage
            id="templates.connect_failed.reload-page"
            defaultMessage="Reload page"
            description="Reload page"
          />
        </Button>
      </div>
    </div>
  );
};
